<template>
    <div>
        <div class="container" v-if="!loading && hasDraft">
            <h1>Direct Invoice Draft</h1>
            <div class="printblock border border-1 shadow p-3 mb-5 bg-white rounded mx-auto" >
                <div class="row g-0">
                    <div class="col-12 py-0 bg-light px-1 rounded border border-1 shadow-sm mb-3">
                        <div class="container border-bottom border-1 mb-0">
                            <div class="row align-items-center">
                                <img
                                    v-if="showHeaderLogo"
                                    :src="headerLogoUrl"
                                    alt="logo"
                                    class="object-fit-contain col-4 pb-0"
                                    style="height: 2cm;"
                                >
                                <h3 :class="headerTitleClass">{{ headerTitle }}</h3>
                            </div>
                        </div>
                        <div class="row g-0">
                            <div class="col-8 p-1 border-end border-1">
                                <div class="d-flex flex-column align-items-start">
                                    <p class="m-0" style="text-align: justify;"><b>Address: </b>{{ billerAddress + ', ' + billerContact + ', ' + billerEmail }},</p>
                                    <p class="mb-1 mt-0 mx-0 " style="text-align: justify;"><b>PAN: </b> {{ billerPan }}, <b>GST: </b> {{ billerGst==null? 'N/A': billerGst }}</p>
                                    <p v-if="billerTaxDetails" class="mb-1 mt-0 mx-0 " style="text-align: justify;"><b>Note: </b> {{ billerTaxDetails }}</p>
                                </div>
                            </div>
                            <div class="col-4 d-xl-flex justify-content-xl-end align-items-xl-center px-3">
                                <div class="d-flex flex-column align-items-start">
                                <b>Invoice No:</b><input type="text" v-model="invoice.invoice_no"><b>Invoice Date:</b>{{getCurrentDate()}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 py-0 bg-light px-1 rounded border border-1 shadow-sm mb-3">
                        <div class="container border-bottom border-1 mb-0">
                            <h4 class="pb-0">Payee Details</h4>
                        </div>
                        <div class="row g-0">
                            <div class="col-12 p-1 ">
                                <div class="d-flex flex-column align-items-start">
                                    <label class="form-label mb-1"><b>Name</b></label>
                                    <input class="form-control form-control-sm mb-2" v-model="invoice.payee_name" type="text" placeholder="Payee name" />
                                    <label class="form-label mb-1"><b>Address</b></label>
                                    <input class="form-control form-control-sm mb-2" v-model="invoice.payee_address" type="text" placeholder="Payee address" />
                                    <label class="form-label mb-1"><b>Contact No.</b></label>
                                    <input class="form-control form-control-sm mb-2" v-model="invoice.payee_contact_no" type="text" placeholder="Payee contact number" />
                                    <label class="form-label mb-1"><b>Email</b></label>
                                    <input class="form-control form-control-sm mb-2" v-model="invoice.payee_email" type="email" placeholder="Payee email" />
                                    <div class="row w-100 g-2">
                                        <div class="col-md-6">
                                            <label class="form-label mb-1"><b>PAN</b></label>
                                            <input class="form-control form-control-sm" v-model="invoice.payee_pan" type="text" placeholder="Payee PAN" />
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label mb-1"><b>GST</b></label>
                                            <input class="form-control form-control-sm" v-model="invoice.payee_gst" type="text" placeholder="Payee GST" />
                                        </div>
                                    </div>
                                    <label class="form-label mb-1 mt-2"><b>Tax Details / Note</b></label>
                                    <textarea class="form-control form-control-sm" rows="2" v-model="invoice.payee_tax_details" placeholder="Optional payee tax details"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 py-0 bg-light px-1 rounded border border-1 shadow-sm mb-3 noprint">
                        <div class="container border-bottom border-1 mb-0">
                            <h4 class="pb-0">Add Billables</h4>
                        </div>
                        <div class="row g-2 p-2">
                            <div class="col-md-9 d-flex align-items-start">
                                <otherSelect
                                    v-model="billableToAdd"
                                    :options="availableBillables"
                                    :multi-mode="false"
                                    :object-mode="true"
                                    dispVal="name"
                                    label="Search Billable"
                                    placeholder="Type to search billables"
                                    formClass="w-100 shadow shadow-contrast"
                                />
                            </div>
                            <div class="col-md-3 d-flex align-items-start">
                                <button class="btn btn-primary btn-lg bi-plus-lg w-100" @click.prevent="addSelectedBillable" :disabled="!billableToAdd">Add Item</button>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 px-1">
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col" class="text-start" style="width: 80px;">#</th>
                              <th v-if="showHsn" scope="col" class="text-start">HSN / SAC</th>
                              <th scope="col" class="text-start">Description</th>
                              <th scope="col" class="text-end" >Qty</th>
                              <th scope="col" class="text-end" >Cost</th>
                              <th scope="col" class="text-end" >Sub Total</th>
                              <th scope="col" class="text-end noprint" >Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="invoice.billables.length < 1">
                                <td class="text-start" :colspan="showHsn ? 7 : 6">No billables added. Use search above and click Add Item.</td>
                            </tr>
                            <template v-for="(item,index) in invoice.billables" :key="index">
                              <tr>
                                <th scope="row" class="text-start" style="width: 80px;">{{ index+1 }}</th>
                                <td v-if="showHsn" class="text-start align-top">{{ item.hsn || '-' }}</td>
                                <td>
                                    <textarea class="form-control form-control-sm invoice-line-note" rows="2" v-model="item.description" placeholder="Line item description"></textarea>
                                </td>
                                <td class="d-flex justify-content-end" >
                                  <input class="text-end form-control" type="number" min="1" step="1" v-model="item.qty" @change.prevent="item.subTotal=item.qty*item.cost;setTotal();">
                                </td>
                                <td class="text-end" >
                                  <b>{{ curr[currency].symbol }}</b><input class="text-end form-control float-end" type="number" min=".00" step=".01" v-model="item.cost" @change.prevent="item.subTotal=item.qty*item.cost;setTotal();">
                                </td>
                                <td class="text-end" >{{ formatCurrency(item.subTotal) }}</td>
                                <td class="text-end noprint">
                                    <button class="btn btn-sm btn-outline-danger" @click.prevent="removeBillable(index)">Remove</button>
                                </td>
                              </tr>
                              <tr v-if="item.taxes && item.taxes.length > 0" class="table-light">
                                <td></td>
                                <td :colspan="showHsn ? 4 : 3" class="text-start"><small><b>Taxes:</b></small></td>
                                <td class="text-end">
                                  <div v-for="(tax, tidx) in item.taxes" :key="tidx" style="font-size: 0.9em;">
                                    <small>{{ tax.shortcode || tax.short || tax.name || tax }} ({{ getTaxPercentage(tax) }}%): {{ formatCurrency(calculateTaxAmount(item.subTotal, tax)) }}</small>
                                  </div>
                                </td>
                                <td class="noprint"></td>
                              </tr>
                              <tr v-if="item.taxes && item.taxes.length > 0" class="table-light">
                                <td></td>
                                <td :colspan="showHsn ? 4 : 3" class="text-start"><small><b>Amount with Tax:</b></small></td>
                                <td class="text-end"><small><b>{{ formatCurrency(calculateBillableWithTax(item)) }}</b></small></td>
                                <td class="noprint"></td>
                              </tr>
                            </template>
                            <tr class="table-secondary text-white">
                                <td></td>
                                <th scope="row" class="text-start" :colspan="showHsn ? 4 : 3">Total (with all taxes) ===></th>
                                <td class="text-end"><b> {{ formatCurrency(getTotal) }}</b></td>
                                <td class="noprint"></td>
                            </tr>
                            <tr class="table-secondary text-white">
                                <td></td>
                                <td scope="row" class="text-start" :colspan="showHsn ? 5 : 4"><b>In words: </b><i> {{ convertToWords(getTotal,currency) }}</i></td>
                                <td class="noprint"></td>
                            </tr>
                          </tbody>
                        </table>
                    </div>

                    <div class="col-12" >
                        <termsinput v-if="invoice['terms']" :terms="invoice['terms']['delivery']" :title="'Terms Of Delivery'" @terms="invoice['terms']['delivery']=$event"/>
                        <hr/>
                        <termsinput v-if="invoice['terms']" :terms="invoice['terms']['payment']" :title="'Terms Of Payment'" @terms="invoice['terms']['payment']=$event"/>
                        <hr/>
                        <div class="card mb-3">
                            <div class="card-header bg-secondary text-white fw-bold py-1">Note</div>
                            <div class="card-body p-2">
                                <textarea
                                    class="form-control form-control-sm invoice-note-text"
                                    rows="3"
                                    placeholder="Additional note"
                                    aria-label="Note"
                                    v-model="invoice.note"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="col-12 py-0 bg-light px-1 rounded border border-1 shadow-sm mb-3">
                        <div class="container border-bottom border-1 mb-0">
                            <h4 class="pb-0">Payment Option / Bank Details</h4>
                        </div>
                        <div class="row g-0">
                            <div class="col-12 p-1 ">
                                <div class="d-flex flex-column align-items-start">
                                    <otherSelect
                                        v-model="selectedAccount"
                                        :options="ddHolder.bank_accounts"
                                        :multi-mode="false"
                                        :object-mode="true"
                                        dispVal="name"
                                        label="Search Bank Account"
                                        placeholder="Type to search bank account"
                                        formClass="w-100"
                                    />
                                    <p class="m-0" style="text-align: justify;"><b>Name on Account: </b>{{ invoice.bank_account_name || '-' }}</p>
                                    <p class="m-0" style="text-align: justify;"><b>Bank Name: </b>{{ invoice.bank_name || '-' }}</p>
                                    <p class="m-0" style="text-align: justify;"><b>Account No.: </b>{{ invoice.bank_account_no || '-' }}</p>
                                    <p class="m-0" style="text-align: justify;"><b>IFSC Code: </b>{{ invoice.bank_branch_ifsc || '-' }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="noprint d-flex align-items-center gap-3 mb-2">
                            <div class="form-check form-switch mb-0">
                                <input class="form-check-input" type="checkbox" id="showHsnToggleGen" v-model="showHsn">
                                <label class="form-check-label" for="showHsnToggleGen">Show HSN / SAC in description</label>
                            </div>
                            <div class="form-check form-switch mb-0">
                                <input class="form-check-input" type="checkbox" id="roundTaxToggle" v-model="roundTax">
                                <label class="form-check-label" for="roundTaxToggle">Round tax amounts</label>
                            </div>
                        </div>
                        <div class="btn-group noprint" role="group" aria-label="Invoice Actions">
                            <button type="button" class="btn btn-primary" @click.prevent="requestActionCaptcha({ title: 'Confirm Generate', promptText: 'Solve the sum to generate and save this invoice.', confirmLabel: 'Generate', action: () => saveInvoice() })">Save</button>
                            <button type="button" class="btn btn-danger" @click.prevent="initializeDirectInvoice()">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="container py-4">
            <div class="spinner-border text-primary" role="status"></div>
        </div>

        <ActionCaptchaModal
          :show="showActionCaptcha"
          :title="captchaTitle"
          :prompt-text="captchaPromptText"
          :confirm-label="captchaConfirmLabel"
          @close="closeActionCaptcha"
          @confirmed="confirmActionCaptcha"
        />
    </div>
</template>
<script>
import { convertToWords } from '@/parts/numwords';
import { dropDownLinks, invoiceLinks, entityLinks } from '@/cd-links';
import termsinput from '@/parts/termsinput.vue';
import otherSelect from '@/parts/otherSelect.vue';
import ActionCaptchaModal from '@/components/mods/ActionCaptchaModal.vue';

export default {
    name: 'DirectInvoiceView',
    components: {
        termsinput,
        otherSelect,
        ActionCaptchaModal
    },
    data() {
        return {
            loading: false,
            hasDraft: false,
            selectedAccount: null,
            billableToAdd: null,
            invoice: {},
            ddHolder: {
                billables: [],
                bank_accounts: [],
            },
            roundTax: true,
            showHsn: false,
            showActionCaptcha: false,
            captchaTitle: 'Confirm Action',
            captchaPromptText: 'Please solve this quick check to continue.',
            captchaConfirmLabel: 'Confirm',
            pendingAction: null,
            currency: 'INR',
            curr: {
                INR: { name: 'Indian Rupee', code: 'INR', symbol: '₹' },
                USD: { name: 'United States Dollar', code: 'USD', symbol: '$' },
                EUR: { name: 'Euro', code: 'EUR', symbol: '€' },
                GBP: { name: 'British Pound Sterling', code: 'GBP', symbol: '£' },
                RUB: { name: 'Russian Ruble', code: 'RUB', symbol: '₽' }
            }
        };
    },
    computed: {
        getEntity() {
            return this.$store.getters.getEntity;
        },
        getUser() {
            return this.$store.getters.getUser;
        },
        getTotal() {
            let grandTotal = 0;
            this.invoice.billables.forEach((item) => {
                let itemTotal = Number(item.subTotal) || 0;
                if (Array.isArray(item.taxes) && item.taxes.length > 0) {
                    item.taxes.forEach((tax) => {
                        itemTotal += this.calculateTaxAmount(item.subTotal, tax);
                    });
                }
                grandTotal += itemTotal;
            });
            return grandTotal;
        },
        headerType() {
            return this.invoice.biller_header_type || 'entity_name_only';
        },
        headerLogoUrl() {
            return this.invoice.biller_header_logo_url || this.invoice.biller_header_logo_path || null;
        },
        showHeaderLogo() {
            return !!this.headerLogoUrl && ['logo_only', 'logo_entity_name', 'logo_custom_text'].includes(this.headerType);
        },
        headerTitle() {
            const billerName = this.invoice.biller_name || '';
            if (['logo_custom_text', 'custom_text_only'].includes(this.headerType)) {
                return this.invoice.biller_header_custom_text || billerName;
            }
            return billerName;
        },
        headerTitleClass() {
            if (this.showHeaderLogo) return 'col-8 pb-0 text-start';
            if (['entity_name_only', 'custom_text_only'].includes(this.headerType)) return 'col-12 pb-0 text-center';
            return 'col-12 pb-0 text-start';
        },
        billerAddress() {
            return this.invoice.biller_address || '';
        },
        billerContact() {
            return this.invoice.biller_contact_no || '';
        },
        billerEmail() {
            return this.invoice.biller_email || '';
        },
        billerPan() {
            return this.invoice.biller_pan || '';
        },
        billerGst() {
            return this.invoice.biller_gst || null;
        },
        billerTaxDetails() {
            const val = this.invoice.biller_tax_details;
            if (val == null) return '';
            if (typeof val === 'string') return val;
            try {
                return JSON.stringify(val);
            } catch (_) {
                return String(val);
            }
        },
        availableBillables() {
            const selectedIds = new Set(this.invoice.billables.map((b) => Number(b.id)));
            return this.ddHolder.billables.filter((b) => !selectedIds.has(Number(b.id)));
        }
    },
    methods: {
        buildBlankInvoice(base = {}) {
            return {
                creatorId: Number(this.getUser?.id) || 0,
                user_id: Number(this.getUser?.id) || 0,
                name: 'Direct Invoice',
                type: 'One-Off',
                status: 1,
                recurrence: 'None',
                biller_id: Number(this.getEntity) || 0,
                biller_name: base.name || '',
                biller_email: base.email || '',
                biller_contact_no: base.contact_no || '',
                biller_address: base.address || '',
                biller_gst: base.gst || '',
                biller_pan: base.pan || '',
                biller_tax_details: base.tax_details || '',
                biller_header_type: base.entity_header?.header_type || 'entity_name_only',
                biller_header_custom_text: base.entity_header?.custom_text || null,
                biller_header_logo_path: base.entity_header?.logo_path || null,
                biller_header_logo_url: base.entity_header?.id ? `/entityheader/image/${base.entity_header.id}` : null,
                payee_id: 0,
                payee_name: '',
                payee_email: '',
                payee_contact_no: '',
                payee_address: '',
                payee_gst: '',
                payee_pan: '',
                payee_tax_details: '',
                acc_id: null,
                bank_id: null,
                bank_name: '',
                bank_branch_id: null,
                bank_branch_name: '',
                bank_branch_ifsc: '',
                bank_account_id: null,
                bank_account_name: '',
                bank_account_no: '',
                tax_id: [],
                billables: [],
                terms: { delivery: [], payment: [] },
                note: null,
                invoice_no: ''
            };
        },
        requestActionCaptcha({ title, promptText, confirmLabel, action }) {
            this.captchaTitle = title || 'Confirm Action';
            this.captchaPromptText = promptText || 'Please solve this quick check to continue.';
            this.captchaConfirmLabel = confirmLabel || 'Confirm';
            this.pendingAction = typeof action === 'function' ? action : null;
            this.showActionCaptcha = true;
        },
        closeActionCaptcha() {
            this.showActionCaptcha = false;
            this.pendingAction = null;
        },
        confirmActionCaptcha() {
            const action = this.pendingAction;
            this.showActionCaptcha = false;
            this.pendingAction = null;
            if (typeof action === 'function') action();
        },
        setInvoiceNo(prefix, number) {
            const now = new Date();
            const fy = `${now.getFullYear()}-${(now.getFullYear() + 1).toString().slice(-2)}`;
            if (!prefix) {
                this.invoice.invoice_no = `INV-${number}`;
                return;
            }
            switch (prefix) {
                case '$FY':
                    this.invoice.invoice_no = `${fy}-${String(number).padStart(6, '0')}`;
                    break;
                case '$CY':
                    this.invoice.invoice_no = `${now.getFullYear()}-${String(number).padStart(6, '0')}`;
                    break;
                default:
                    this.invoice.invoice_no = `${prefix}-${number}`;
                    break;
            }
        },
        formatCurrency(value) {
            const numeric = Number(value);
            if (Number.isNaN(numeric)) return 'Invalid value';
            const currencySymbol = this.curr[this.currency]?.symbol || '^';
            const formattedValue = this.currency !== 'INR'
                ? numeric.toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 })
                : numeric.toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
            return `${currencySymbol}${formattedValue}`;
        },
        convertToWords(num, curr) {
            return convertToWords(num, curr);
        },
        setTotal() {
            this.invoice.billables.forEach((item) => {
                item.subTotal = Number(item.qty || 0) * Number(item.cost || 0);
            });
        },
        calculateTaxAmount(subTotal, tax) {
            if (!tax) return 0;
            let percentage = 0;
            if (typeof tax === 'object' && tax.perc !== undefined) percentage = Number(tax.perc);
            else if (typeof tax === 'object' && tax.percentage !== undefined) percentage = Number(tax.percentage);
            else if (typeof tax === 'string') percentage = Number(tax);
            const raw = (Number(subTotal) * percentage) / 100;
            return this.roundTax ? Math.round(raw) : raw;
        },
        calculateBillableWithTax(item) {
            let total = Number(item.subTotal) || 0;
            if (Array.isArray(item.taxes)) {
                item.taxes.forEach((tax) => {
                    total += this.calculateTaxAmount(item.subTotal, tax);
                });
            }
            return total;
        },
        getTaxPercentage(tax) {
            if (!tax) return 0;
            if (typeof tax === 'object' && tax.perc !== undefined) return Number(tax.perc);
            if (typeof tax === 'object' && tax.percentage !== undefined) return Number(tax.percentage);
            if (typeof tax === 'string') return Number(tax);
            return 0;
        },
        getCurrentDate() {
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const today = new Date();
            const day = String(today.getDate()).padStart(2, '0');
            const month = months[today.getMonth()];
            const year = today.getFullYear();
            return `${day}-${month}-${year}`;
        },
        normalizeTermList(terms, removeEmpty = true) {
            if (!Array.isArray(terms)) return [];
            const normalized = terms.map((term) => String(term ?? '').trim());
            return removeEmpty ? normalized.filter((term) => term.length > 0) : normalized;
        },
        sanitizeTermsPayload(terms, removeEmpty = true) {
            const source = terms && typeof terms === 'object' ? terms : {};
            return {
                delivery: this.normalizeTermList(source.delivery, removeEmpty),
                payment: this.normalizeTermList(source.payment, removeEmpty)
            };
        },
        parseTaxes(rawTaxes) {
            if (Array.isArray(rawTaxes)) return rawTaxes;
            if (typeof rawTaxes === 'string') {
                try {
                    const parsed = JSON.parse(rawTaxes);
                    return Array.isArray(parsed) ? parsed : [];
                } catch (_) {
                    return [];
                }
            }
            return [];
        },
        addSelectedBillable() {
            if (!this.billableToAdd || !this.billableToAdd.id) return;
            const exists = this.invoice.billables.some((item) => Number(item.id) === Number(this.billableToAdd.id));
            if (exists) {
                this.$store.commit('addAlert', {
                    title: 'Duplicate Item',
                    message: 'This billable is already added.',
                    type: 'warning'
                });
                return;
            }

            const item = {
                id: Number(this.billableToAdd.id),
                name: this.billableToAdd.name || '',
                hsn: this.billableToAdd.hsn || null,
                qty: 1,
                cost: Number(this.billableToAdd.cost || 0),
                currency: this.billableToAdd.currency || this.currency,
                taxes: this.parseTaxes(this.billableToAdd.taxes),
                description: this.billableToAdd.description || '',
                subTotal: Number(this.billableToAdd.cost || 0)
            };

            this.invoice.billables.push(item);
            this.currency = item.currency || this.currency;
            this.setTotal();
            this.billableToAdd = null;
        },
        removeBillable(index) {
            this.invoice.billables.splice(index, 1);
            this.setTotal();
        },
        applySelectedAccount(account) {
            if (!account || !account.id) return;
            this.invoice.acc_id = Number(account.id);
            this.invoice.bank_account_id = Number(account.id);
            this.invoice.bank_account_name = account.name || '';
            this.invoice.bank_account_no = account.account_no || '';
            this.invoice.bank_branch_id = account.bank_branch?.id || null;
            this.invoice.bank_branch_name = account.bank_branch?.name || '';
            this.invoice.bank_branch_ifsc = account.bank_branch?.ifsc || '';
            this.invoice.bank_id = account.bank_branch?.bank?.id || null;
            this.invoice.bank_name = account.bank_branch?.bank?.name || '';
        },
        async getDropDownData(table, listName, filter) {
            const resp = await this.$store.getters.getAxios.post(dropDownLinks[table], { ent_id: this.$store.getters.getEntity, filter });
            if (!resp.data.isLoggedIn) {
                this.$store.dispatch('loggedOut');
                return;
            }
            this.ddHolder[listName] = resp.data.data;
        },
        async loadBillerBase() {
            const resp = await this.$store.getters.getAxios.post(entityLinks.getItem, { id: this.getEntity });
            if (!resp.data.isLoggedIn) {
                this.$store.dispatch('loggedOut');
                return null;
            }
            if (!resp.data.data) return null;
            return resp.data.data;
        },
        async initializeDirectInvoice() {
            this.loading = true;
            this.hasDraft = false;
            this.selectedAccount = null;
            this.billableToAdd = null;
            try {
                await Promise.all([
                    this.getDropDownData('billables', 'billables', 0),
                    this.getDropDownData('accounts', 'bank_accounts', 0)
                ]);

                const biller = await this.loadBillerBase();
                this.invoice = this.buildBlankInvoice(biller || {});
                const nextInvoiceNo = Number((biller?.last_invoice_no || 0)) + 1;
                this.setInvoiceNo(biller?.invoice_prefix, nextInvoiceNo);
                this.hasDraft = true;
            } catch (_) {
                this.$store.commit('addAlert', {
                    title: 'Error Initializing Direct Invoice',
                    message: 'Unable to load billables/accounts for direct invoice.',
                    type: 'danger'
                });
            } finally {
                this.loading = false;
            }
        },
        async saveInvoice() {
            if (!String(this.invoice.payee_name || '').trim()) {
                this.$store.commit('addAlert', {
                    title: 'Validation Error',
                    message: 'Payee name is required for Direct Invoice.',
                    type: 'warning'
                });
                return;
            }
            if (!Array.isArray(this.invoice.billables) || this.invoice.billables.length < 1) {
                this.$store.commit('addAlert', {
                    title: 'Validation Error',
                    message: 'Add at least one billable item.',
                    type: 'warning'
                });
                return;
            }
            if (!Number(this.invoice.bank_account_id)) {
                this.$store.commit('addAlert', {
                    title: 'Validation Error',
                    message: 'Select a bank account for payment details.',
                    type: 'warning'
                });
                return;
            }

            const payload = {
                template_id: -1,
                source_template_id: null,
                creatorId: Number(this.invoice.creatorId || this.getUser?.id || 0),
                user_id: Number(this.invoice.user_id || this.getUser?.id || 0),
                name: String(this.invoice.name || 'Direct Invoice'),
                type: String(this.invoice.type || 'One-Off'),
                status: 1,
                recurrence: String(this.invoice.recurrence || 'None'),
                note: this.invoice.note || null,
                biller_id: Number(this.invoice.biller_id || this.getEntity),
                biller_name: String(this.invoice.biller_name || ''),
                biller_email: this.invoice.biller_email || null,
                biller_contact_no: this.invoice.biller_contact_no || null,
                biller_address: this.invoice.biller_address || null,
                biller_gst: this.invoice.biller_gst || null,
                biller_pan: this.invoice.biller_pan || null,
                biller_tax_details: this.invoice.biller_tax_details || null,
                payee_id: 0,
                payee_name: String(this.invoice.payee_name || '').trim(),
                payee_email: this.invoice.payee_email || null,
                payee_contact_no: this.invoice.payee_contact_no || null,
                payee_address: this.invoice.payee_address || null,
                payee_gst: this.invoice.payee_gst || null,
                payee_pan: this.invoice.payee_pan || null,
                payee_tax_details: this.invoice.payee_tax_details || null,
                acc_id: Number(this.invoice.acc_id),
                bank_id: Number(this.invoice.bank_id),
                bank_name: this.invoice.bank_name,
                bank_branch_id: Number(this.invoice.bank_branch_id),
                bank_branch_name: this.invoice.bank_branch_name,
                bank_branch_ifsc: this.invoice.bank_branch_ifsc || null,
                bank_account_id: Number(this.invoice.bank_account_id),
                bank_account_name: this.invoice.bank_account_name,
                bank_account_no: this.invoice.bank_account_no,
                tax_id: [],
                billables: this.invoice.billables,
                terms: this.sanitizeTermsPayload(this.invoice.terms),
                invoice_no: this.invoice.invoice_no || null
            };

            this.loading = true;
            try {
                const resp = await this.$store.getters.getAxios.post(invoiceLinks.post, payload);
                if (!resp.data.isLoggedIn) {
                    this.$store.dispatch('loggedOut');
                    return;
                }
                this.$store.commit('addAlert', {
                    title: resp.data.title,
                    message: resp.data.msg,
                    type: resp.data.success ? 'success' : 'danger'
                });
                if (resp.data.success) {
                    await this.initializeDirectInvoice();
                }
            } catch (_) {
                this.$store.commit('addAlert', {
                    title: 'Error Saving Invoice',
                    message: 'Try after some time',
                    type: 'danger'
                });
            } finally {
                this.loading = false;
            }
        }
    },
    watch: {
        selectedAccount(newValue) {
            this.applySelectedAccount(newValue);
        }
    },
    async mounted() {
        await this.initializeDirectInvoice();
    }
};
</script>
<style scoped>
[type="number"] {
    /* max-width: 300px; */ /* Set the maximum width */
    /* width: 100%; */ /* Make it responsive */
    max-width: 100px !important; /* Set the maximum width */
}
.printblock{
    font-size: 3mm !important;
    width: 210mm; /* A4 width */
    /* height: 297mm; */ /* A4 height */
    /* padding: 10mm; */ /* Optional: content padding */
  }
.invoice-line-note,
.invoice-note-text {
    font-size: 0.72rem;
    line-height: 1.25;
    white-space: pre-line;
    text-align: left;
}
@media print {
  body{
    visibility: hidden;
  }
  .noprint{
    display: none !important;
  }
  .printblock{
    visibility: visible;
    position: absolute;
    top: 0;
    left: 0;
    page-break-after: always; /* Force page break after each A4 block */
  }
}
</style>